export default __webpack_public_path__ + "static/media/tete37.88db01a2.png";